import user from './user'
import axios from 'axios'

export default {
  login (context, credentials) {
    return new Promise((resolve, reject) => {
      var responses = {};
      var errors = {}
      user.loginWebApi(credentials).then(response => {
        context.commit('setApiToken', response.data.success.token)
        context.commit('setUser', response.data.success.user)
        context.commit('setLogged', true)
        context.commit('setMenu', response.data.success.menu)
        document.cookie = 'Session_Cookie=' + response.data.success.token
        window.axios.defaults.headers.post['Authorization'] = 'Bearer ' + $cookies.get('Session_Cookie');
        window.axios.defaults.headers.get['Authorization'] = 'Bearer ' + $cookies.get('Session_Cookie');
        window.axios.defaults.headers.put['Authorization'] = 'Bearer ' + $cookies.get('Session_Cookie');
        window.axios.defaults.headers.delete['Authorization'] = 'Bearer ' + $cookies.get('Session_Cookie');
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  logout (context) {
    return new Promise((resolve, reject) => {
      user.logoutWebApi().then(response => {
        context.commit('setLogged', false)
        context.commit('setApiToken', '')
        context.commit('setUser', {})
        $cookies.remove('Session_Cookie')
        resolve(response)
        window.location.replace("/login")

      }).catch(error => {
        reject(error)

      });
    })

  },
  test(context){
    return new Promise((resolve, reject) => {
      resolve("Ejecutando")
      
      reject("Sin ejecutar")
    });
  }
  
}
